import { QueryClient, QueryKey } from '@tanstack/react-query'

import { chatNotificationQuery } from '../../presentation/hooks/queries/chatNotificationQuery'
import { ticketChatUserNotificationQuery } from '../../presentation/hooks/queries/ticketChatUserNotificationQuery'
import { userNotificationQuery } from '../../presentation/hooks/queries/userNotificationsQuery'

export function setChatNotificationsCount(
  {
    count
  }: {
    count: number
  },
  queryClient: QueryClient
) {
  queryClient.setQueryData<number | undefined, QueryKey, number>(
    chatNotificationQuery.getNotificationsQueryKey(),
    count
  )
}

export function setUserNotificationsCount(
  {
    count
  }: {
    count: number
  },
  queryClient: QueryClient
) {
  queryClient.setQueryData<number | undefined, QueryKey, number>(
    userNotificationQuery.getNotificationsQueryKey(),
    count
  )
}

export function setTicketChatUserNotificationCount(
  {
    count
  }: {
    count: number
  },
  queryClient: QueryClient
) {
  queryClient.setQueryData<number | undefined, QueryKey, number>(
    ticketChatUserNotificationQuery.getNotificationsQueryKey(),
    count
  )
}
